export enum EXPERIENCE_STATUS_ENUM {
  DRAFT = "DRAFT",
  DEPLOYED = "DEPLOYED",
  DEPLOYING = "DEPLOYING",
  DEPLOYED_DRAFT_WAITING = "DEPLOYED_DRAFT_WAITING",
  DEPLOYED_FAILED = "DEPLOYED_FAILED",
}
